<template>
  <div class="text-center loading">
    <span class="loader"></span>
  </div>
</template>

<script>
export default {
  name: "TableLoading",
}
</script>

<style scoped>
.loading{
  margin-top: 10rem;
}
.loader {
  width: 48px;
  height: 48px;
  display: inline-block;
  position: relative;
}
.loader::after,
.loader::before {
  content: '';
  box-sizing: border-box;
  width: 98px;
  height: 98px;
  border-radius: 50%;
  border: 2px solid #FF6600;
  position: absolute;
  left: 0;
  top: 0;
  animation: animloader 2s linear infinite;
}
.loader::after {
  animation-delay: 1s;
}

@keyframes animloader {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

</style>
